import { useTheme } from "@mui/material";
import PropTypes from "prop-types";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import NotificationsIcon2 from "@mui/icons-material/Notifications";
import WarningIcon2 from "@mui/icons-material/Warning";
import DoneIcon2 from "@mui/icons-material/Done";
import DoneAllIcon2 from "@mui/icons-material/DoneAll";
import StarIcon2 from "@mui/icons-material/Star";
import StarOutlineIcon2 from "@mui/icons-material/StarOutline";

export function DoneIcon(props) {
  return <DoneIcon2 {...props} />;
}
export function DoneAllIcon(props) {
  return <DoneAllIcon2 {...props} />;
}
export function NotificationsIcon(props) {
  return <NotificationsIcon2 color="primary" {...props} />;
}
export function WarningIcon(props) {
  return <WarningIcon2 {...props} />;
}

export function HourglassIcon(props) {
  return <HourglassEmptyIcon color="warning" {...props} />;
}

export function YesNoIcon({ success, ...props }) {
  if (success) {
    return <YesIcon {...props} />;
  }
  return <NoIcon {...props} />;
}
YesNoIcon.propTypes = {
  success: PropTypes.bool,
};

export function YesIcon({ color = "success", ...props }) {
  const theme = useTheme();
  const iconColor = theme.palette[color].main;

  return (
    <span style={{ color: iconColor }}>
      <AiOutlineCheckCircle size={24} {...props} />
    </span>
  );
}
YesIcon.propTypes = {
  color: PropTypes.string,
};
YesIcon.displayName = "YesIcon";

export function NoIcon(props) {
  const theme = useTheme();
  const { color = "error" } = props;
  const iconColor = theme.palette[color].main;
  return (
    <span style={{ color: iconColor }}>
      <AiOutlineCloseCircle size={24} {...props} />
    </span>
  );
}
NoIcon.propTypes = {
  color: PropTypes.string,
};

export function ResultIcon({ success, ...props }) {
  if (success) {
    return <SuccessIcon {...props} />;
  }
  return <ErrorIcon {...props} />;
}
ResultIcon.propTypes = {
  success: PropTypes.bool,
};

export function ErrorIcon(props) {
  return <ErrorOutlineIcon color="error" {...props} />;
}
export function SuccessIcon(props) {
  return <DoneIcon color="success" {...props} />;
}
export function StarFilledIcon(props) {
  return <StarIcon2 color="primary" {...props} />;
}
export function StarOutlineIcon(props) {
  return <StarOutlineIcon2 color="primary" {...props} />;
}
